import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import vuefire from 'vuefire'
import auth from '@/auth'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueScrollTo from 'vue-scrollto'

import './fa.config';

const snotifyOptions = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

import 'vue-snotify/styles/simple.css'

Vue.use(vuefire)
Vue.use(Snotify)
Vue.use(auth)
Vue.use(Snotify, snotifyOptions)
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
